import { adjustPageNo } from '@/util';
import AssignmentsTable from '@components/AssignmentsTable';
import ButtonRow from '@components/ButtonRow';
import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useState } from 'react';

import { ListSummary } from '@/types/shared';
import { PanelContent } from './types';

const DEFAULT_ASSIGNMENTS_PAGE_SIZE = 5;

interface DashboardTabProps {
  list: ListSummary | undefined;
  rightPanelOpen: boolean;
  handleOpenRightPanel: (content: PanelContent) => void;
  isLoading: boolean;
}

export default function DashboardTab({
  list,
  rightPanelOpen,
  handleOpenRightPanel,
  isLoading,
}: DashboardTabProps) {
  const unassignedContactsCount = (list?.count ?? 0) - (list?.numAssigned ?? 0);

  const [pageSize, setPageSize] = useState(DEFAULT_ASSIGNMENTS_PAGE_SIZE);
  const [pageNo, setPageNo] = useState(0);

  const onPaginationModelChange = (model: { page: number; pageSize: number }) => {
    setPageSize(model.pageSize);
    setPageNo(
      model.pageSize !== pageSize ? adjustPageNo(pageSize, pageNo, model.pageSize) : model.page
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
      }}>
      <Typography component="h3" variant="h6" sx={{ marginTop: '-2rem' }}>
        Assignments
      </Typography>
      <AssignmentsTable
        isLoading={isLoading}
        data={list?.assignees ?? []}
        paginationModel={{ page: pageNo, pageSize }}
        onPaginationModelChange={onPaginationModelChange}
        listName={list?.name || ''}
        listId={list?.id || 0}
      />

      <ButtonRow noMarginX sx={{ margin: 0 }}>
        {list?.count !== list?.numAssigned && !isLoading && (
          <strong>
            {unassignedContactsCount} {unassignedContactsCount === 1 ? 'contact' : 'contacts'} to be
            assigned
          </strong>
        )}

        <Button
          variant="contained"
          disabled={rightPanelOpen || isLoading}
          onClick={() => handleOpenRightPanel('assign')}
          data-testid="listDetailPage-assign"
        >
          Assign
        </Button>
      </ButtonRow>
    </Box>
  );
}
